<template>
  <div>
    <Header />
    <router-view />
    <Footer />
    <!-- 回到顶部 -->
    <div class="top-btn" @click="scrollToTop">↑<br>Top</div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  components: {
    Header: () => import('@/components/Header'),
    Footer: () => import('@/components/Footer')
  },
  mounted() {
    window.addEventListener('scroll', () => {
      document.querySelector('.top-btn').style.display = window.scrollY > 1000 ? 'flex' : 'none'
    })
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-btn {
  position: fixed;
  right: 15%;
  transform: translateX(115%);
  bottom: 50px;
  width: 100px;
  aspect-ratio: 1;
  border-radius: 50%;
  color: $theme-color;
  font-size: 18px;
  font-weight: bold;
  display: none;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: 300ms;
  z-index: 99;

  &::before {
    content: '';
    display: inline-block;
    width: 110px;
    aspect-ratio: 1;
    position: absolute;
    border: 1.5px solid #999;
    border-radius: 50%;
  }

  &:hover {
    background: $theme-color;
    color: #fff;

    &::before {
      border-color: $theme-color;
    }
  }
}
</style>